<ng-container *ngIf="(userInfo && !loading); else waiting">
    <div class="row">
        <!-- sezione ricerca -->
        <app-advanced-search [customSearch]="advSearch.getConfigAdv()" (callSearch)="searchParams($event)"
            (callButton)="callButton($event)"></app-advanced-search>
            <div *ngIf="primaRicerca">
                <h5 title="Rimuovere i filtri di ricerca renderà la ricerca molto lenta e potrebbe non restituire risultati in quanto la richiesta va in timeout">Ricerca di default attivata - vengono mostrati i documenti dell'anno corrente {{this.anno}}</h5>
            </div>
        <hr>
    </div>

    <ng-container *ngIf='dataTable; else waiting'>
        <div class="row" style="margin-bottom: 10px;" *ngIf="dataTable.length>0">
            <div [ngClass]="{'col' : innerWidth! > 767, 'col-12': innerWidth! <= 767}" class="text-center text-md-left">
                <!--   <div style="float: right; display: flex; align-items: start;">-->
                <div class="d-inline-block" style="float:left">
                    <div ngbDropdown class="d-inline-block" style="margin-right: 5px">
                        <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" id="dropdownBasic3"
                            ngbDropdownToggle style="margin-right: 0px "><i class="bi bi-download"></i>
                            {{'invoices.button.downloadSelected'
                            |
                            translate}}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <button ngbDropdownItem (click)='downloadSelected()'>{{'invoices.dropdown.downloadSelected'
                                |
                                translate}}</button>
                            <button ngbDropdownItem (click)="downloadAll('DWNZIPE');">{{'invoices.dropdown.downloadAll'
                                |
                                translate}}</button>
                        </div>
                    </div>
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 1rem;"
                        (click)='setDownload(2)'><i class="bi bi-file-check"></i> {{'invoices.button.alreadyDownloaded'
                        | translate}} </button>
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 1rem; "
                        (click)='setDownload(0)'><i class="bi bi-file-earmark-arrow-down"></i>
                        {{'invoices.button.toDownload' | translate}} </button>
                    <div ngbDropdown class="d-inline-block" style="margin-right: 5px">
                        <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px"
                            id="dropdownBasic4" ngbDropdownToggle><i class="bi bi-file-earmark-excel"></i>
                        {{'invoices.button.downloadSelectedExcel' | translate}} </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
                            <button ngbDropdownItem (click)='downloadCSV()'>{{'invoices.dropdown.downloadSelected'
                                |
                                translate}}</button>
                            <button ngbDropdownItem (click)="downloadAll('DWNCSVE');">{{'invoices.dropdown.downloadAll'
                                |
                                translate}}</button>
                        </div>
                    </div>
                    <div ngbDropdown class="d-inline-block" style="margin-right: 1rem;">
                        <button class="btn btn-light btn-sm mb-1 w-xs-100" id="dropdownBasic2" ngbDropdownToggle
                            style='margin: 0px'>
                            <i class="bi bi-file-earmark-pdf"></i> {{'invoices.button.generateAndDownloadSelectedPDF' |
                            translate}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                            <button ngbDropdownItem (click)="downloadPDF('')">{{'invoices.dropdown.assoFormat' |
                                translate}}</button>
                            <button ngbDropdownItem (click)="downloadPDF('min');">{{'invoices.dropdown.minFormat' |
                                translate}}</button>

                        </div>
                    </div>
                    <div *ngIf="labels" ngbDropdown class="d-inline-block" style="margin-right: 1rem;">
                        <button class="btn btn-light btn-sm mydropdown" id="dropdownBasic3" ngbDropdownToggle>
                            <i class="bi bi-tags"></i> {{'invoices.button.labels' | translate}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <button *ngFor='let label of labels' ngbDropdownItem (click)='assignTag(label)'>
                                <img [src]="'assets/icone_varie/tag_' +label.style +'.svg'"
                                    style='width:16px;height:auto'>
                                {{label.etichetta}}
                            </button>

                        </div>
                    </div>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div>
            <div class="row justify-content-between" style="margin-bottom: 10px; margin-top:10px">
                <div class='col-auto' style="display: flex; flex-direction: row;">
                    <label class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
                    <div class="dm7Select">
                        <div class="select-side">
                            <img src="assets/icone_varie/arrow_down.svg">
                        </div>
                        <app-select class="selectDm7" [options]="pages" [key]="'key'" [value]="'key'"
                            [placeholder]="'placeholder.select' | translate" [addNull]="false"
                            [selectedKey]="params.get('pageSize')" (change)="changePageSize($event.key)"></app-select>
                    </div>
                    <label class="form-check-label">{{'paginator.rows' | translate}}</label>
                </div>
                <div class='col-4' style="float: right;">
                    <app-paginator *ngIf="paginator" [config]="paginator" (refresh)="getDataTable()" (next)="next()"
                        (prev)="prev()" (setPage)="setPage($event)"></app-paginator>
                </div>
                <div class="row justify-content-between" style="margin-bottom: 10px; margin-top:10px">
                    <div class='col-auto' style="float: right;">
                        {{file_selected}} {{'invoices.selectedFiles' | translate}} <button *ngIf="file_selected > 0"
                            type="button" class="btn btn-sm mb-1 w-xs-100" style="margin-left: 10px "
                            (click)='deselectAll()'><i class="bi bi-x-circle"></i>
                            {{'invoices.undoSelection' | translate}}</button>
                    </div>
                </div>
            </div>
            <div *ngIf="dataTable.length>0; else noRes">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col" style="max-width: 40px; width: 30px;"></th>
                            <th scope="col" style=" max-width: 40px; width: 30px;"><input type="checkbox"
                                    style="margin-left:-4px" class="form-check-input" id="predef"
                                    [(ngModel)]="allSelected" (ngModelChange)="setSelected()"></th>
                            <th class="d-print-none" scope="col" style="max-width: 60px; width: 60px;">
                                {{'invoices.table.tipo' | translate}}</th>
                            <th scope="col">{{'invoices.table.num' | translate}}</th>
                            <th scope="col" style="max-width: 100px; width: 100px;">{{'invoices.table.date' |
                                translate}}</th>
                            <th scope="col" style="cursor: pointer;">{{'invoices.table.receiver' | translate}}</th>
                            <th scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.amount' |
                                translate}}</th>
                            <th scope="col">{{'invoices.table.status' | translate}}</th>
                            <th scope="col" class="d-print-none">
                                {{'invoices.table.sdi' | translate}}
                                <br />{{'invoices.table.dateTimeReceived' | translate}}
                            </th>
                            <!--<th scope="col" class="d-print-none">{{'invoices.table.dateTimeReceived' | translate}}</th>-->
                            <th class="d-print-none" style="max-width: 60px; width: 60px;" scope="col">
                                {{'invoices.table.notific' | translate}}</th>
                            <th class="d-print-none" scope="col" style="cursor: pointer;">
                                {{'invoices.table.fileName' | translate}} </th>

                            <th class="d-print-none" scope="col" style="cursor: pointer;">
                                {{'invoices.table.dateCreated' | translate}} </th>
                            <th scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.actions' |
                                translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataTable; index as i;"  [ngClass]="{'draft':item.workflow_state_code === 'draft'}">
                            <td>
                                <div style='display: flex; flex-direction: column;'>
                                    <img [src]="'assets/icone_varie/' + (item.download==1 ? 'check_1' : item.download==0? 'email': 'download') + 
                            (item.workflow_state_code === 'draft'? '_rosso.svg' : '.svg') "
                                        [ngbTooltip]="(getTooltip(item) | translate)"
                                        style='width:16px;height:auto; margin-bottom : 10px'>

                                    <ng-container *ngIf='getTag(item.tags).length>0'>
                                        <img [ngbTooltip]="getTag(item.tags)[1]"
                                            [src]="'assets/icone_varie/tag_' +getTag(item.tags)[0] +'.svg' "
                                            style='width:16px;height:auto'>
                                    </ng-container>
                                </div>
                            </td>
                            <td>

                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input" id="predef"
                                        [(ngModel)]="item.selected" (ngModelChange)="checkAllSelected()"
                                        (click)='$event.stopPropagation();'>
                                </div>
                            </td>
                            <td class="d-print-none" width="1%">{{getType(item.tags)}}</td>
                            <td (click)='openPreview(item.id, item.file_name, i)'>{{item["Numero fattura"]}}</td>
                            <td (click)='openPreview(item.id, item.file_name, i)'>
                                {{stringToDate(item["Data fattura"]!, "DD-MM-YYYY")}}
                            </td>
                            <!--<td>{{item.NumeroFattura}}</td>
                        <td>{{item.IdentificativoSdi==''? 'n/a' : item.IdentificativoSdi}}</td>
                        <td>{{stringToDate(item.DataFattura!, "DD/MM/YYYY")}}</td>-->
                            <td>{{item.denominazione}}</td>
                            <td
                                title="Imponibile: {{getImponibile(item.tags)}}, imposta: {{getImposta(item.tags)}}">
                                {{item.Importo}}</td>
                            <!--<td>{{item.DataScadenzaFattura}}</td>
                        
                        <td>{{item.DataRicezione}}</td>-->
                            <td><strong>{{item.workflow_state}}</strong></td>
                            <td class="d-print-none">
                                {{item.IdentificativoSdI}}
                                <br>{{stringToDate(item.DataOraRicezione, "DD-MM-YYYY HH:mm")}}
                            </td>
                            <!--<td class="d-print-none">{{item.DataOraRicezione}}</td>-->
                            <td width="1%" class="d-print-none">
                                <div ngbDropdown class="d-inline-block">
                                    <card class='ghost' id="dropdownBasic1" ngbDropdownToggle
                                        (click)='$event.stopPropagation(); getNotifications(item.relateds)'>
                                        {{item.relateds.length}}
                                        <img [src]="'assets/icone_varie/notifica' + (item.workflow_state_code=='draft'? '_rosso.svg' : '.svg')"
                                            style='width:15px'>
                                    </card>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
                                        *ngIf='item.relateds.length>0'>
                                        <button *ngFor='let n of notifications' ngbDropdownItem
                                            (click)="$event.stopPropagation();openNotification(item.id, n.id, n.file_name)">{{n.file_name}}</button>

                                    </div>
                                </div>
                            </td>

                            <td class="d-print-none" style='word-break: break-all;'>{{item.title}}
                                <img *ngIf="item.conservato" title="Conservato"
                                    [src]="'assets/icone_varie/seal.svg' " style='width:16px; height:auto'>
                                <img *ngIf="item.e_signed" title="Fattura firmata digitalmente"
                                    [src]="'assets/icone_varie/signed.svg' " style='width:16px; height:auto'>
                                <img *ngIf="getAllegati(item.tags)" title="La fattura contiene allegati"
                                    [src]="'assets/icone_varie/paperclip.svg' " style='width:16px; height:auto'>
                            </td>

                            <td class="d-print-none">{{stringToDate(item.date_created, "DD-MM-YYYY HH:mm:ss")}}</td>
                            <td class='btnCol'>
                                <div ngbDropdown class="d-inline-block">
                                    <button class="btn btn-primary mydropdown" id="dropdownBasic1" ngbDropdownToggle
                                        (click)='$event.stopPropagation()'>
                                        <img src="assets/icone_varie/azione.svg" style="width: 25px;">
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button ngbDropdownItem (click)="downloadFile('file', item.id, i)">{{'invoices.dropdown.downloadFile' | translate}}</button>
                                        <button ngbDropdownItem (click)="downloadFile('xml', item.id, i)">{{'invoices.dropdown.downloadXml' | translate}}</button>
                                        <button ngbDropdownItem (click)="downloadFile('allegati', item.id, i)">{{'invoices.dropdown.downloadAllegati' | translate}}</button>
                                        <button ngbDropdownItem (click)="showPreviewMinisteriale(item.id, item.file_name, i); $event.stopPropagation()">{{'invoices.dropdown.preview' | translate}}</button>
                                        <button ngbDropdownItem *ngIf='item.workflow_state_code=="draft"' (click)="goToEditor(item.id); $event.stopPropagation()">{{'invoices.dropdown.modify' | translate}}</button>
                                        <button ngbDropdownItem *ngIf='item.workflow_state_code=="draft" || item.workflow_state_code=="s2sc"' (click)="cancellaBozza(item.id); $event.stopPropagation()" >{{'invoices.dropdown.delete' | translate}}</button>
                                    </div>
                                </div>
                            </td>


                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <br>




    </ng-container>
    <ng-template #noRes>
        <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </div>
    </ng-template>


</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>